/* eslint-disable react/prop-types */
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Chip from '@mui/material/Chip'
import { PLAN_LABELS, PLAN_COLORS, HIDDEN_PLAN_KEYS } from '../../../shared/constants/planLabels'

const EDITABLE_PLAN_KEYS = Object.keys(PLAN_LABELS).filter((key) => !HIDDEN_PLAN_KEYS.includes(key))

function PlansSelect({ labelId, value, onChange }) {
  return (
    <FormControl fullWidth margin="normal">
      <InputLabel id={labelId}>Planos</InputLabel>
      <Select
        labelId={labelId}
        label="Planos"
        multiple
        value={value}
        onChange={(event) => onChange(event.target.value)}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((plan) => (
              <Chip
                key={plan}
                label={PLAN_LABELS[plan] ?? plan}
                size="small"
                sx={PLAN_COLORS[plan] && { backgroundColor: PLAN_COLORS[plan].background, color: PLAN_COLORS[plan].color }}
              />
            ))}
          </Box>
        )}
      >
        {EDITABLE_PLAN_KEYS.map((plan) => (
          <MenuItem key={plan} value={plan}>
            {PLAN_LABELS[plan]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default PlansSelect
